export default __webpack_public_path__ + "static/media/GenericAdd.d93420d1.svg";